import HTTPRequest from '../index'

const apiPath = '/api/v2/users'

export type JourneyStepPayload = {
  step: string
  user_treatment_id?: number | string | null
  metadata?: Record<string, unknown>
}

export type ClientErrorPayload = {
  error_type: string
  error_code?: string
  message: string
  url?: string
  component?: string
  stack_trace?: string
  metadata?: Record<string, unknown>
}

class TrackerRequest extends HTTPRequest {
  recordStep(payload: JourneyStepPayload) {
    return this.post(`${apiPath}/journey/step`, payload, {
      headers: { 'skip-loading': true },
    } as any)
  }

  logError(payload: ClientErrorPayload) {
    return this.post(`${apiPath}/client-errors`, payload, {
      headers: { 'skip-loading': true },
    } as any)
  }
}

export default new TrackerRequest()
